var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.info.type,attrs:{"module-item":""}},[_c('ul',_vm._l((_vm.info.value),function(row,i){return _c('li',{key:i,class:row.award},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.enterToBr(row.text))}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }